import { Outlet, Route, Routes } from "react-router-dom";
import "./App.css";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/Auth/LoginPage";
import RegistrationPage from "./pages/Auth/RegistrationPage";
import ExploreBrands from "./pages/ExploreBrands";
import WatchCollection from "./pages/WatchCollection";
import Valuation from "./pages/Valuation";
import NotFound from "./pages/NotFound";
import GlobalLayout from "./layout/GlobalLayout";
import DealerInfo from "./pages/DealerInfo";
import DelarRegistration from "./pages/Auth/DelarRegistration";
// import DealarLayout from "./layout/DealerLayout";
import GetReadyForDealerRegistration from "./pages/Auth/GetReadyForDealerRegistration";
import UserProfileLayout from "./layout/UserProfileLayout";
import OverView from "./pages/ProfileUser/OverView";
import WatchDescription from "./pages/WatchDescription";

// import Sell from "./pages/ProfileUser/Sell";
// import Notepad from "./pages/ProfileUser/Notepad";
// import WatchCollectionUserProfile from "./pages/ProfileUser/WatchCollectionUserProfile";
import UserProfile from "./pages/ProfileUser/UserProfile";
import Notifications from "./pages/ProfileUser/Notifications";
import Messages from "./pages/ProfileUser/Messages";
// import SavedSearch from "./pages/ProfileUser/SavedSearch";
import Supplier from "./pages/Supplier";
import FrequentlyAskedQuestions from "./pages/FrequentlyAskedQuestions";
import SubscriptionPlan from "./pages/SubscriptionPlan";
import CreateListing from "./pages/ProfileUser/CreateListing";
import MyInventory from "./pages/ProfileUser/MyInventory";
import Statistics from "./pages/ProfileUser/Statistics";
import ListingPreview from "./pages/ListingPreview";
import CreateListingSummery from "./pages/CreateListingSummery";
import { Toaster } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { isDealerLoggedIn } from "./redux/actions";
import PrivateRoute from "./components/HOC/PrivateRoute";
import { SupplierDetails } from "./pages/SupplierDetails";
import { SupplierListing } from "./pages/SupplierListing";
import LearnMorePage from "./pages/LearnMorePage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import { AboutUs } from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import { ForgotPass } from "./pages/Auth/ForgotPass";
import { ResetPass } from "./pages/Auth/ResetPass";

function App() {
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!auth.authenticate) {
      dispatch(isDealerLoggedIn());
    }
  }, []);
  return (
    <div className="">
      <Routes>
        <Route
          path={"/"}
          element={
            <GlobalLayout>
              <HomePage />
            </GlobalLayout>
          }
        />
        <Route
          path={"/home"}
          element={
            <GlobalLayout>
              <HomePage />
            </GlobalLayout>
          }
        />
        <Route
          path={"/learn-more"}
          element={
            <GlobalLayout>
              <LearnMorePage />
            </GlobalLayout>
          }
        />

        <Route
          path={"/explore-brands"}
          element={
            <GlobalLayout>
              <ExploreBrands />
            </GlobalLayout>
          }
        />

        <Route
          path={"/supplier/listings/:id"}
          element={
            <GlobalLayout>
              <SupplierListing />
            </GlobalLayout>
          }
        />

        <Route
          path={"/supplier/details/:id"}
          element={
            <GlobalLayout>
              <SupplierDetails />
            </GlobalLayout>
          }
        />

        <Route
          path={"/categories"}
          element={
            <GlobalLayout>
              <ExploreBrands />
            </GlobalLayout>
          }
        />
        <Route
          path={"/watch"}
          element={
            <GlobalLayout>
              <WatchDescription />
            </GlobalLayout>
          }
        />
        <Route
          path={"/services/watch-collection"}
          element={
            <GlobalLayout>
              <WatchCollection />
            </GlobalLayout>
          }
        />
        <Route
          path={"/services/valuation"}
          element={
            <GlobalLayout>
              <Valuation />
            </GlobalLayout>
          }
        />
        <Route
          path={"/dealerinfo"}
          element={
            <GlobalLayout>
              <DealerInfo />
            </GlobalLayout>
          }
        />

        <Route
          path={"/supplier"}
          element={
            <GlobalLayout>
              <Supplier />
            </GlobalLayout>
          }
        />
        <Route
          path={"/faqs"}
          element={
            <GlobalLayout>
              <FrequentlyAskedQuestions />
            </GlobalLayout>
          }
        />
        <Route
          path={"/dealer-info/get-started"}
          element={
            <GlobalLayout>
              <GetReadyForDealerRegistration />
            </GlobalLayout>
          }
        />
        <Route
          path={"/dealer-info/subcription-plan"}
          element={
            <GlobalLayout>
              <SubscriptionPlan />
            </GlobalLayout>
          }
        />
        <Route
          path={"/dealer-info/registration-info"}
          element={
            <GlobalLayout>
              <DelarRegistration />
            </GlobalLayout>
          }
        />
        <Route
          path={"/listing/preview"}
          element={
            <GlobalLayout>
              <ListingPreview />
            </GlobalLayout>
          }
        />
        <Route
          path={"/privacy-policy"}
          element={
            <GlobalLayout>
              <PrivacyPolicy />
            </GlobalLayout>
          }
        />
        <Route
          path={"/about-us"}
          element={
            <GlobalLayout>
              <AboutUs />
            </GlobalLayout>
          }
        />
        <Route
          path={"/contact-us"}
          element={
            <GlobalLayout>
              <ContactUs />
            </GlobalLayout>
          }
        />
        <Route
          path={"/listing/create-listing"}
          element={
            <GlobalLayout>
              <CreateListingSummery />
            </GlobalLayout>
          }
        />
        <Route
          path={"/user"}
          element={
            <PrivateRoute>
              <UserProfileLayout>
                <Outlet />
              </UserProfileLayout>
            </PrivateRoute>
          }
        >
          <Route index element={<OverView />} />
          <Route path={"index"} element={<OverView />} />
          <Route path={"overview"} element={<OverView />} />
          <Route path={"messenger"} element={<Messages />} />
          <Route path={"create-listing"} element={<CreateListing />} />
          <Route path={"my-inventory"} element={<MyInventory />} />
          <Route path={"statistics"} element={<Statistics />} />

          <Route path={"data"} element={<UserProfile />} />
          <Route path={"settings"} element={<Notifications />} />
          <Route path={"*"} element={<NotFound />} />
        </Route>
        <Route path={"/auth/login"} element={<LoginPage />} />
        <Route path={"/auth/forgot-password"} element={<ForgotPass />} />
        <Route path={"/auth/reset-password"} element={<ResetPass />} />
        <Route path={"/auth/user/register"} element={<RegistrationPage />} />
        <Route
          path={"*"}
          element={
            <GlobalLayout>
              <NotFound />
            </GlobalLayout>
          }
        />
      </Routes>
      <Toaster />
    </div>
  );
}

export default App;
